import service from '../service.js'

export default{

    getRequest(){
        return service.get('official-business')
    },
    getobData(ref_no){
        return service.get('ob-data', {
            ref_no : ref_no
        })
    },
    notedRequest(ref_no){
        return service.get('ob-noted', {
            ref_no : ref_no
        })
    },

}